"use strict";
/*
 * Created on 01 04 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var EntityAttribute_1 = require("../model/EntityAttribute");

var EntityAttributeConverter_1 = require("./EntityAttributeConverter");
/**
 * Implementation of {@link EntityAttributeConverter}
 *
 * @author JMe
 */


var EntityAttributeConverterImpl =
/*#__PURE__*/
function (_EntityAttributeConve) {
  _inherits(EntityAttributeConverterImpl, _EntityAttributeConve);

  function EntityAttributeConverterImpl() {
    _classCallCheck(this, EntityAttributeConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(EntityAttributeConverterImpl).apply(this, arguments));
  }

  _createClass(EntityAttributeConverterImpl, [{
    key: "toDocument",

    /**
     * @inheritDoc
     */
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        clazzId: source.clazzId,
        clazzName: source.clazzName,
        attributeId: source.attributeId,
        attributeName: source.attributeName,
        entityId: conversions.toDocumentReferenceId(source.entityId),
        validFrom: conversions.fromDate(source.validFrom),
        validTo: conversions.fromDate(source.validTo)
      });
      return result;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      return new EntityAttribute_1.EntityAttribute(EntityAttribute_1.EntityAttribute.schema.id.valueOf(conversions.documentToClassId(source)), EntityAttribute_1.EntityAttribute.schema.clazzId.valueOfField(source), EntityAttribute_1.EntityAttribute.schema.clazzName.valueOfField(source), EntityAttribute_1.EntityAttribute.schema.attributeId.valueOfField(source), EntityAttribute_1.EntityAttribute.schema.attributeName.valueOfField(source), EntityAttribute_1.EntityAttribute.schema.entityId.valueOf(conversions.toClassReferenceId(source.entityId)), EntityAttribute_1.EntityAttribute.schema.validFrom.valueOfField(source), EntityAttribute_1.EntityAttribute.schema.validTo.valueOfField(source));
    }
  }]);

  return EntityAttributeConverterImpl;
}(EntityAttributeConverter_1.EntityAttributeConverter);

exports.EntityAttributeConverterImpl = EntityAttributeConverterImpl;